import { useContext, useEffect, useState } from 'react';
import catchCancel from 'helpers/catchCancel';
import { parseServerError } from 'helpers/errorHelpers';
import { Context } from 'components/Store';
import useCropSeasonServiceApi from 'hooks/useCropSeasonServiceApi';
import {
  CROP_SEASON_FETCH_V2,
  CROP_SEASON_FETCH_V2_BY_ORG,
  CROP_SEASON_CREATE_V2,
  CROP_SEASON_CREATE_V2_BY_ORG,
  CROP_SEASON_UPDATE_V2,
  CROP_SEASON_UPDATE_V2_BY_ORG
} from 'constants/cropSeasonServiceV2Flags';

const useCropSeasonData = id => {
  const [, dispatch] = useContext(Context);
  const fetchApi = useCropSeasonServiceApi(
    'cropseason',
    CROP_SEASON_FETCH_V2,
    CROP_SEASON_FETCH_V2_BY_ORG
  );
  const createApi = useCropSeasonServiceApi(
    'cropseason',
    CROP_SEASON_CREATE_V2,
    CROP_SEASON_CREATE_V2_BY_ORG
  );
  const updateApi = useCropSeasonServiceApi(
    'cropseason',
    CROP_SEASON_UPDATE_V2,
    CROP_SEASON_UPDATE_V2_BY_ORG
  );

  const [cropSeason, setCropSeason] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const isCreateScreen = id === 'season';
    let cancel;
    if (!isCreateScreen && id) {
      const { promise, cancel: _cancel } = fetchApi.fetch(
        id,
        undefined,
        undefined,
        undefined,
        true // ignoreCache
      );
      cancel = _cancel;
      promise
        .then(({ data }) => {
          setCropSeason(data);
        })
        .catch(catchCancel)
        .catch(err => {
          parseServerError(dispatch)(err);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
    return () => cancel && cancel();
  }, [dispatch, id, fetchApi]);

  const saveCropSeason = values => {
    const isCreateScreen = id === 'season';
    setSaving(true);

    const saveValues = values;

    const { promise } = isCreateScreen
      ? createApi.create(saveValues)
      : updateApi.update(id, saveValues);

    return promise
      .catch(catchCancel)
      .catch(parseServerError(dispatch))
      .finally(() => {
        setSaving(false);
      });
  };

  return {
    cropSeason,
    loading,
    saving,
    saveCropSeason
  };
};

export default useCropSeasonData;
